
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Goatothaneacab() {



    const cardData =
    {
        keyword: 'Goa to Thane Cab',
        heading: 'S9 Travels: Goa to Thane Cab',
        headingDescription: 'S9 Travels offers Goa to Thane Cab Service, ensuring a comfortable, safe, and hassle-free journey. Whether you are returning from a vacation or traveling for business, our well-maintained cabs, including spacious Innova vehicles, provide a smooth and enjoyable ride. Enjoy on-time pickups, professional drivers, affordable pricing, and 24/7 service for a seamless travel experience. Book your Goa to Thane Cab with S9 Travels and enjoy a stress-free journey with comfort and convenience!',


        top: 'Top Places to Visit in Thane with S9 Travels',

"topPlaces": [
    {
      "title": "Upvan Lake",
      "description": "One of the most picturesque lakes in Thane, Upvan Lake is a popular spot for relaxation and evening strolls. Surrounded by lush greenery and the Yeoor Hills, it offers a serene environment, making it an ideal place for nature lovers and photography enthusiasts."
    },
    {
      "title": "Yeoor Hills",
      "description": "A haven for trekkers and nature lovers, Yeoor Hills is a part of the Sanjay Gandhi National Park. It offers beautiful trails, waterfalls, and a refreshing escape from the city's hustle. Early mornings are perfect for a peaceful hike amidst greenery."
    },
    {
      "title": "Tikuji-ni-Wadi",
      "description": "A popular amusement and water park, Tikuji-ni-Wadi is a great destination for families and kids. It features thrilling rides, a water park, and even a dinosaur park, ensuring a fun-filled day for visitors of all ages."
    },
    {
      "title": "Kelva Beach",
      "description": "Located a short drive from Thane, Kelva Beach is a serene coastal destination known for its clean shores and scenic beauty. It's a great spot for weekend getaways, beach walks, and water sports."
    },
    {
      "title": "Elvis Butterfly Garden",
      "description": "A hidden gem in Thane, the Elvis Butterfly Garden is home to a variety of butterfly species. It's an excellent place for nature lovers, kids, and photographers looking to witness the beauty of butterflies in a natural setting."
    },
    {
      "title": "Masunda Lake (Talao Pali)",
      "description": "One of Thane’s most iconic landmarks, Talao Pali offers boating facilities and a scenic promenade. Visitors can enjoy an evening walk, try local street food, or simply relax by the lake while admiring the view."
    },
    {
      "title": "Kachrali Lake",
      "description": "A peaceful lake in the heart of Thane, Kachrali Lake is surrounded by jogging tracks and seating areas, making it a great place for morning exercise or an evening retreat."
    },
    {
      "title": "Suraj Water Park",
      "description": "A thrilling water park with exciting rides, Suraj Water Park is a fantastic place to beat the heat. It features wave pools, giant slides, and fun-filled activities, making it a favorite among kids and families."
    },
    {
      "title": "Ovalekar Wadi Butterfly Garden",
      "description": "An eco-friendly butterfly garden, Ovalekar Wadi is a must-visit for those who appreciate wildlife and nature. The guided tours provide valuable insights into the lifecycle of butterflies and their natural habitat."
    },
    {
      "title": "Gaimukh Chowpatty",
      "description": "A scenic waterfront area in Thane, Gaimukh Chowpatty is perfect for spending a peaceful evening by the water. It offers boat rides and street food stalls, making it a great spot for relaxation."
    }
],

"services": [
  {
    "name": "Goa to Thane Cab Service",
    "description": "Book a reliable and comfortable cab from Goa to Thane with S9 Travels. Whether you're traveling for business, leisure, or any other occasion, we offer both one-way and round-trip services to suit your needs. Our professional drivers and well-maintained vehicles ensure that your journey to this vibrant city is safe, smooth, and enjoyable."
  },
  {
    "name": "Book Goa to Thane Taxi",
    "description": "Booking a taxi from Goa to Thane is simple and convenient with S9 Travels. We offer one-way and round-trip options, giving you flexibility and ensuring that you travel in comfort and style. Our fleet of well-maintained vehicles and experienced drivers ensure a smooth and reliable journey."
  },
  {
    "name": "Affordable Goa to Thane Cab",
    "description": "Travel affordably from Goa to Thane with S9 Travels. We offer cost-effective cab services that don’t compromise on comfort, safety, or reliability. Whether you're looking for a one-way trip or a round trip, we provide budget-friendly options to make your journey comfortable without exceeding your budget."
  },
  {
    "name": "Private Taxi for Thane from Goa",
    "description": "Travel privately and comfortably with a dedicated taxi from Goa to Thane. Our private taxis offer a personalized and uninterrupted travel experience, tailored to your preferences. Choose from a range of vehicles to ensure a comfortable, smooth, and private journey."
  },
  {
    "name": "Goa to Thane One-Way or Round Trip",
    "description": "S9 Travels offers flexible one-way and round-trip taxi services from Goa to Thane. Whether you’re in need of a quick one-way trip or prefer the flexibility of a round-trip service, we ensure a smooth, comfortable, and timely journey to fit your schedule."
  },
  {
    "name": "Comfortable Taxi Ride from Goa to Thane",
    "description": "Enjoy a comfortable, stress-free taxi ride from Goa to Thane with S9 Travels. Our clean and well-maintained vehicles, paired with experienced chauffeurs, ensure that your journey is both relaxing and enjoyable. Whether for business, leisure, or personal reasons, your comfort is our priority."
  },
  {
    "name": "Luxury Cab for Goa to Thane",
    "description": "Indulge in a luxurious travel experience with S9 Travels' premium cabs from Goa to Thane. Our luxury vehicles are equipped with top-notch amenities, providing you with the highest level of comfort and privacy. Whether traveling alone or with others, enjoy a premium ride that makes your journey feel special."
  },
  {
    "name": "Group Travel from Goa to Thane by Taxi",
    "description": "Planning a group trip from Goa to Thane? S9 Travels offers spacious vehicles that can accommodate large groups comfortably. Whether you are traveling with family, friends, or colleagues, our taxis ensure a smooth, safe, and enjoyable journey for everyone."
  },
  {
    "name": "Thane Sightseeing Tour from Goa by Cab",
    "description": "Explore the sights and attractions of Thane with a sightseeing tour from Goa by taxi. Visit popular destinations such as Upvan Lake, Kelva Fort, and the Suraj Water Park. Our professional drivers will guide you through the city’s must-see landmarks, ensuring a comfortable and informative experience."
  }
],

"tableData": [
  ["Goa to Thane Cab Service", "Book Goa to Thane Taxi"],
  ["Affordable Goa to Thane Cab", "Private Taxi for Thane from Goa"],
  ["Goa to Thane One-Way or Round Trip", "Comfortable Taxi Ride from Goa to Thane"],
  ["Luxury Cab for Goa to Thane", "Group Travel from Goa to Thane by Taxi"],
  ["Thane Sightseeing Tour from Goa by Cab", ""],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Reliable Long-Distance Travel",
    "WhyChoosedescription": "S9 Travels offers a comfortable Goa to Thane cab service, ideal for long-distance journeys. Our fleet of well-maintained vehicles, including the Toyota Innova, ensures a smooth, comfortable ride with ample space, air conditioning, and plush seating, making your trip enjoyable no matter the distance."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand that timely travel is essential. Our Goa to Thane cab service ensures punctual pick-ups and drop-offs, so you can reach your destination on time without any delays. Whether you're traveling for business, leisure, or a special event, we guarantee reliable service every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions for trips from Goa to Thane. They prioritize safety, comfort, and efficiency, ensuring your journey is smooth and pleasant, no matter the destination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for the Goa to Thane cab service. We provide a transparent pricing structure with no hidden charges. You’ll receive a clear breakdown of the cost during the booking process, allowing you to plan your travel budget without surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Thane Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts to ensure a safe and comfortable journey for you and your passengers throughout your trip from Goa to Thane."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Goa to Thane trip. Whether you need an early morning departure or a late-night return, we’re here to provide reliable service that fits your travel schedule."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Thane Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way, have specific locations to visit, or require special arrangements, we offer customizable itineraries to suit your preferences and make your Goa to Thane journey even more enjoyable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Goa to Thane cab with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance. We strive to make your booking process quick, easy, and convenient."
  }
]






















    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Goa to Thane with S9 Travels?',
            answer: 'Booking a cab from Goa to Thane is simple! You can book your ride via our website, mobile app, or by contacting our customer service team for personalized assistance. We ensure a comfortable and hassle-free journey to Thane.',
          },
          {
            question: 'What types of vehicles are available for a trip from Goa to Thane?',
            answer: 'We offer a variety of vehicles for your trip from Goa to Thane, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the vehicle that best suits your needs based on your group size and preferences.',
          },
          {
            question: 'Are the drivers experienced for the Goa to Thane trip?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes for the Goa to Thane journey. They prioritize your safety, comfort, and ensure a smooth travel experience.',
          },
          {
            question: 'Can I book a round-trip cab from Goa to Thane?',
            answer: 'Yes, you can book a round-trip cab for your journey from Goa to Thane. Simply provide us with your return details, and we will ensure a smooth and timely return journey.',
          },
          {
            question: 'How long in advance should I book a cab for Goa to Thane?',
            answer: 'It is recommended to book your cab at least 1-2 days in advance to secure vehicle availability. However, last-minute bookings can also be accommodated based on availability.',
          },
          {
            question: 'Is there a fixed fare for the Goa to Thane cab service?',
            answer: 'The fare for the Goa to Thane trip depends on the distance, vehicle type, and any special requests. Contact us for a personalized quote with transparent pricing based on your trip details.',
          },
          {
            question: 'Do you offer pick-up services from Goa airport or hotels for the Thane trip?',
            answer: 'Yes, we offer convenient pick-up services from Goa airport or hotels. Our professional drivers will ensure smooth transfer to your cab for a comfortable journey to Thane.',
          },
          {
            question: 'Can I request additional stops along the way during my trip to Thane?',
            answer: 'Yes, we can customize your itinerary to add stops for meals, sightseeing, or other breaks during your trip to Thane. Just let us know during booking to include your preferred stops.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Goa to Thane trip?',
            answer: 'Any extra charges for waiting time or detours will be communicated to you upfront during the booking process. We ensure full transparency in our pricing.',
          },
          {
            question: 'Why should I choose S9 Travels for my Goa to Thane trip?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cab services for your journey from Goa to Thane. With well-maintained vehicles, experienced drivers, and excellent customer service, we ensure a smooth and enjoyable trip.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Goa to Thane with S9 Travels, and the experience was wonderful. The driver was professional, and the vehicle was clean and comfortable. The journey was smooth, and we reached Thane on time. Highly recommend S9 Travels for anyone traveling long distances!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Goa to Thane with S9 Travels was amazing. The vehicle was spacious, and the driver was experienced and friendly. The drive was scenic, and the entire trip was very comfortable. We will definitely choose S9 Travels again for our next journey!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Goa to Thane Cab",
        "description": "Book affordable and reliable Goa to Thane cab services for one-way trips, round trips, and luxury rides. S9 Travels offers private taxi services for a comfortable and scenic journey from Goa to Thane, perfect for sightseeing, group travel, and hassle-free trips.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      
      


    return (
        <div>
         <Helmet>
        <title>Goa to Thane Cab | Affordable Taxi & Comfortable Travel | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Goa to Thane taxi services, including one-way, round-trip, and private cabs. Comfortable and affordable transport for sightseeing tours, group travel, and trips from Goa to Thane with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
     

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/69.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Goatothaneacab;